const enum OperatingSystem {
  LINUX = 'LINUX',
  WINDOWS = 'WINDOWS',
}

export default OperatingSystem;
